import { hasCapability, type User } from "../base";

export const accounting = {
  sync: (user: User) => hasCapability(user, "accounting.sync"),
  read: (user: User) => hasCapability(user, "accounting.read"),
  readReports: (user: User) => hasCapability(user, "accounting.readReports"),
};
